var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.844 17.338c2.643 0 4.797-2.115 4.797-4.717V4.688C12.641 2.105 10.491 0 7.844 0 5.2 0 3.046 2.1 3.046 4.688v7.966c.005 2.583 2.154 4.684 4.798 4.684ZM4.71 4.688c0-1.687 1.406-3.061 3.133-3.061S10.976 3 10.976 4.688v7.938c0 1.702-1.405 3.09-3.132 3.09S4.71 14.342 4.71 12.654V4.688Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.858 8.64c-.461 0-.83.366-.83.812v3.197c0 3.334-2.773 6.044-6.184 6.044s-6.18-2.71-6.18-6.039V9.457a.821.821 0 0 0-.83-.812.825.825 0 0 0-.834.812v3.197c0 3.952 3.075 7.215 7.014 7.623v2.1H4.409a.82.82 0 0 0-.83.812c0 .45.374.811.83.811h6.875a.82.82 0 0 0 .83-.811.821.821 0 0 0-.83-.811H8.678v-2.1c3.94-.409 7.014-3.672 7.014-7.624V9.457a.826.826 0 0 0-.834-.816Z",
    fill: "#fff"
  })));
};
export default SvgMic;